import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const SizeChart = ({ open, onClose, chartData, sizeChartImage }) => {
  const [unit, setUnit] = useState("inch");
  if (!open) return null;

  //  If no data yet, don’t break UI
  if (!chartData || chartData.length === 0) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: 600,
          }}
        >
          Size Chart
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>No size chart available</DialogContent>
      </Dialog>
    );
  }

  //  Headers based on first size row — keeping backend order & no duplicates
  const columns = [];
  chartData[0]?.size_column.forEach((col) => {
    if (!columns.includes(col.column_name)) {
      columns.push(col.column_name);
    }
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: 600,
        }}
      >
        Size Chart
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={() => setUnit("inch")}
            sx={{
              border: "1px solid",
              borderColor: unit === "inch" ? "#e0e0e0" : "#ccc",
              backgroundColor: unit === "inch" ? "#e0e0e0" : "transparent",
              color: "#000",
              "&:hover": {
                backgroundColor: unit === "inch" ? "#d5d5d5" : "#f5f5f5",
              },
              borderRadius: "4px 0 0 4px", // rounded only left side
              textTransform: "none",
              minWidth: "40px",
            }}
          >
            CM
          </Button>

          <Button
            onClick={() => setUnit("cm")}
            sx={{
              border: "1px solid",
              borderColor: unit === "cm" ? "#e0e0e0" : "#ccc",
              backgroundColor: unit === "cm" ? "#e0e0e0" : "transparent",
              color: "#000",
              "&:hover": {
                backgroundColor: unit === "cm" ? "#d5d5d5" : "#f5f5f5",
              },
              borderRadius: "0 4px 4px 0", // rounded only right side
              borderLeft: "0px", // remove double border between buttons
              textTransform: "none",
              minWidth: "40px",
            }}
          >
            IN
          </Button>
        </div>
        <TableContainer
          component={Paper}
          elevation={0} // remove shadow
          sx={{
            borderRadius: "10px",
            mt: 1,
            maxHeight: "400px",
            overflowY: "auto",
            border: "1px solid #e0e0e0", // consistent gray border
            boxShadow: "none",

            // just to be sure
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: 700,
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#f5f5f5",
                    align: "center",
                  }}
                >
                  Brand Size
                </TableCell>
                {columns.map((col, i) => (
                  <TableCell
                    key={i}
                    align="center"
                    sx={{ fontWeight: 700, border: "1px solid #e0e0e0" }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {chartData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: 600,
                      border: "1px solid #e0e0e0",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    {row.size}
                  </TableCell>

                  {columns.map((col, i) => {
                    const dataMatch = row.size_column.find(
                      (c) => c.column_name === col
                    );

                    return (
                      <TableCell
                        key={i}
                        align="center"
                        sx={{ border: "1px solid #e0e0e0" }}
                      >
                        {dataMatch
                          ? unit === "inch"
                            ? `${dataMatch.inch}`
                            : `${dataMatch.cm} cm`
                          : "-"}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {sizeChartImage && (
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <img
              src={sizeChartImage}
              alt="Size chart illustration"
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
              }}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SizeChart;
